import ModalComponent from 'components/common/ModalComponent';
import { showAlert } from 'services/alerts.service';
import { formatDateForInput } from 'utils';
import PropTypes from 'prop-types';

const AgroDataEditModal = ({ isOpen, handleSave, handleClose, selectedAgroData }) => {
  const handleSaveClick = formData => {
    // Guard against null/undefined formData
    if (!formData) {
      showAlert({
        text: 'Form data is missing',
        icon: 'error'
      });
      return;
    }

    // Validate required fields
    const requiredFields = [{ field: 'date', label: 'Created At' }];

    // Check for empty or whitespace-only values
    for (const { field, label } of requiredFields) {
      if (!formData[field] || formData[field].toString().trim() === '') {
        showAlert({
          text: `${label} is required`,
          icon: 'warning'
        });
        return;
      }
    }

    // Transform data for API - map 'date' field to 'createdAt' for PATCH request
    const apiData = {
      ...formData,
      createdAt: formData.date
    };

    // Remove the original 'date' field to avoid confusion
    delete apiData.date;

    handleSave(apiData);
  };

  return (
    <ModalComponent
      title="Edit Agro Data"
      isOpen={isOpen}
      onClose={handleClose}
      onSave={handleSaveClick}
      initialData={selectedAgroData}
    >
      {({ formData, handleChange }) => (
        <form className="space-y-4 w-64" autoComplete="off">
          <label className="block text-sm font-medium">
            Created At *
            <input
              type="datetime-local"
              name="date"
              value={formatDateForInput(formData?.date || '')}
              onChange={handleChange}
              className="w-full mt-1 p-2 border rounded"
            />
          </label>
        </form>
      )}
    </ModalComponent>
  );
};

AgroDataEditModal.propTypes = {
  isOpen: PropTypes.bool,
  handleSave: PropTypes.func,
  handleClose: PropTypes.func,
  selectedAgroData: PropTypes.object
};

export default AgroDataEditModal;
